import {Error404} from './components/Error404'

const NotFound = () => {
  return (
    <div className='d-flex flex-column flex-center text-center p-10'>
      <div className='card card-flush w-lg-650px py-5'>
        <div className='card-body py-15 py-lg-20'>
          <Error404 />
        </div>
      </div>
    </div>
  )
}

export {NotFound}
